import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { ApplicationShared } from 'core';
import { saveLastPath, saveLastApp } from 'routeHistory';

export const RouteHistoryTracker: React.FC = () => {
  const history = useHistory();

  const isFirst = useRef(true);

  useEffect(() => {
    const unlisten = history.listen(({ pathname }) => {
      if (isFirst.current) {

        isFirst.current = false;
      } else {

        saveLastPath(pathname);
        saveLastApp(ApplicationShared.application);
      }
    });
    return unlisten;
  }, [history]);

  return null;
};
import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { ApplicationShared } from 'core';
import { saveLastPath, saveLastApp } from 'routeHistory';

export const RouteHistoryTracker: React.FC = () => {
  const history = useHistory();

  const isFirst = useRef(true);

  useEffect(() => {
    const unlisten = history.listen(({ pathname }) => {
      if (isFirst.current) {

        isFirst.current = false;
      } else {

        saveLastPath(pathname);
        saveLastApp(ApplicationShared.application);
      }
    });
    return unlisten;
  }, [history]);

  return null;
};
